<template>
  <f7-page id="reg-tnc" name="reg-tnc" @page:beforein="getTnc" @page:afterin="afterin">
      <f7-navbar class="view-mobile no-border">
          <f7-nav-left class="back-button">
              <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
          </f7-nav-left>
          <f7-nav-right></f7-nav-right>
      </f7-navbar>

      <div class="block text-align-left pt-0 pb-0 ps-0 pe-0 title">
          <div class="wandr-title-1">{{$t('regis-tnc')}}</div>
      </div>

      <div class="block main-tnc-container">
        <div class="details" v-html="tncList.details"></div>
        <div class="display-flex agreement">
          <div class="pr-sm pb-sm pointer" @click="isAgree = !isAgree">
            <i class="f7-icons " :class="isAgree ? ' text-color-green ' : ' text-color-gray5 '" style="font-size: var(--wandr-font-size-level-2)">checkmark_alt_circle_fill</i>
          </div>
          <div class="fs-14">{{ $t('general-text-tnc-agreement') }}</div>
        </div>
      </div>


      <f7-toolbar style="background-color: var(--f7-color-white)" position="bottom" no-hairline class="toolbar-with-button mt-5 mb-5 view-desktop text-align-center">
          <f7-button round large fill @click="acceptTnc" class="" :disabled="!isAgree" style="width:var(--wandr-desktop-content-width-guest)">{{$t('regis-tnc-accepted')}}</f7-button>
      </f7-toolbar>

      <f7-toolbar position="bottom" no-hairline class="toolbar-with-button view-mobile">
        <f7-button large fill @click="acceptTnc" :disabled="!isAgree">
            {{$t('regis-tnc-accepted')}}
        </f7-button>
      </f7-toolbar>
  </f7-page>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import TokenService from '../../services/token-service';
  export default {
    mounted (){
      if(this.tncList.length === 0){
        this.getTnc();
      }
      /*
      this.$f7.$('.page-content').on('scroll', (e) => {
        var state = e.target
        if(typeof state != 'boolean') {
          state = state.scrollHeight - state.scrollTop - 40 <= state.clientHeight;
        }
        if (state) {
          this.isNextButtonValid= false
        }
      })
      */

      console.log("Register tnc isAxsr : "+this.isAxsr);
      if(this.isAxsr){
        this.setRouterTo('axs-landingpage');
      }
    },
    data() {
      return {
        tncList               : [],
        isNextButtonValid     : true,
        isAgree               : false
      };
    },
    methods: {
      ...mapActions('registration', ['getTnc','acceptTnc']),
      ...mapActions('myinfo', [
        'setRouterTo',
      ]),
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      async getTnc(){
        this.showPreloader();
        const tnc = await this.$api.registration.getTnc();
        this.tncList = tnc;

        console.log("Register tnc (getTnc) isAxsr : "+this.isAxsr);
        this.hidePreloader();
      },
      async acceptTnc(){
        this.showPreloader();
        
        /*
        if(this.isAxsr){
          this.$f7router.navigate("/axsr-register-success");
        }else{
          this.$f7router.navigate("/register-personalise-account");
        }
        */

        this.$f7router.navigate("/register-personalise-account");

        this.hidePreloader();
      },

      backButton() {
          console.log("register tnc backbutton, AXS ? "+this.isAxsr)
          if(this.isAxsr && this.routerTo == "axs-landingpage"){
            TokenService.removeToken()
          }

          switch(this.routerTo) {
              case "axs-landingpage"  : this.$f7router.navigate("/customerDetails"); break;
              default                 : this.$f7router.navigate("/register"); break;
          }
      },
     
    },
    components: {

    },
    computed: {
      ...mapGetters('registration', [
          'isAxsr',
        ]),
      ...mapGetters('myinfo', [
          'routerTo'
        ])
    },
  }
</script>